<template>
    <div class="table-custom">
        <div v-if="loading" style="width: 100%; text-align: center; font-size: 16px; margin: 20px">...Loading</div>
        <div v-else id="table-ranking" class="example-preview table-responsive">
            <table class="table table-vertical-center">
                <tbody>
                <template v-if="dataRanking?.length > 0">
                    <tr v-for="item in dataRanking" :key="item.id" class="row_table" :class="item.highlighted ? 'highlight-my__rank' : ''">
                        <td style="width: 80px;">
                            <span class="breaking-text">{{ item.rankType }}</span>
                        </td>
                        <td style="width: 150px">
                            <span class="breaking-text">{{ item.userId }}</span>
                        </td>
                        <td style="width: 220px">
                            <span class="breaking-text">{{ item.name }}</span>
                        </td>
                        <td v-if="!isMobile" style="width: 250px"> {{ item.department }}</td>
                        <td style="width: 120px; text-align: end">
                            <span>{{ item.score }}</span>
                        </td>
                    </tr>
                </template>
                <template v-else>
                    <tr class="text-center" style="color: white;">
                        <td colspan="7">
                            Không có dữ liệu
                        </td>
                    </tr>
                </template>
                </tbody>
            </table>
            <div style="display: flex; justify-content: center" v-if="showActionGetMore">
                <el-button class="load-more" type="text" @click="loadMore">Xem thêm</el-button>

            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        dataRanking: {
            type: Array,
            required: true,
            default: () => []
        },
        total: {
            type: Number,
            required: true,
            default: 0
        },
        loading: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            isMobile: window.innerWidth < 768,
        }
    },
    computed: {
        showActionGetMore() {
            return this.dataRanking && this.dataRanking.length > 0 && this.dataRanking?.length % 10 === 0 && this.dataRanking.length < this.total
        }
    },
    methods: {
        loadMore() {
            this.$emit('loadMore')
        }
    }
}
</script>

<style>
    .row_table {
        border: none !important;
        color: white;
    }
    #table-ranking table tr td{
        border: none !important;
    }
    #table-ranking .example-preview{
        background: linear-gradient(to bottom, #AFA4F7, #503694)
    }
    .table-custom{
        padding: 0 80px;
    }
    #table-ranking .load-more {
        color: #ffa000;
    }
    #table-ranking .load-more:hover {
        color: #fbc02d !important;
        text-decoration: underline !important;
    }
    #table-ranking .highlight-my__rank {
        background: linear-gradient(to right, #AFA4F7, #503694);
    }
    .highlight-my__rank td:first-child {
        border-top-left-radius: 9999px !important;
        border-bottom-left-radius: 9999px !important;
        overflow: hidden;
    }

    .highlight-my__rank td:last-child {
        border-top-right-radius: 9999px !important;
        border-bottom-right-radius: 9999px !important;
        overflow: hidden;
    }
    @media only screen and (max-width: 1024px) {
        .table-custom{
            padding: 0 20px !important;
        }
    }
</style>
